<template>
    <div class="app-view-template-industry-profile">

      <app-view-template-secondary :title="title" :brands="brands">

        <app-section-default-template>
          <app-content-title :label="industryName">
            <airlines-svg v-if="industryName === 'Airlines'" :classes="'industry-icon airlines-icon'"></airlines-svg>
            <financial-svg v-else-if="industryName === 'Financial'" :classes="'industry-icon  financial-icon'"></financial-svg>
            <malls-svg v-else-if="industryName === 'Malls'" :classes="'industry-icon  malls-icon'"></malls-svg>
            <hospitality-svg v-else-if="industryName === 'Hospitality'" :classes="'industry-icon  hospitality-icon'"></hospitality-svg>
            <telecom-svg v-else-if="industryName === 'Telecom'" :classes="'industry-icon  telecom-icon'"></telecom-svg>
            <media-svg v-else-if="industryName === 'Media'" :classes="'industry-icon  media-icon'"></media-svg>
          </app-content-title>

          <slot />

        </app-section-default-template>

        <div class="buttons-wrapper">
          <app-button-secondary-black :text="'Let\'s have a talk'" v-on:click.native="onButtonClick('Contact')"/>

          <app-button-primary v-if="casesRouteName" :text="'See cases'" v-on:click.native="onButtonClick(casesRouteName)"/>
        </div>

      </app-view-template-secondary>

    </div>
</template>

<script>
  import AppViewTemplateSecondary from '@/components/layout/templates/view/AppViewTemplateSecondary';
  import AppButtonPrimary from '@/components/ui/buttons/AppButtonPrimary';
  import AppButtonSecondaryBlack from '@/components/ui/buttons/AppButtonSecondaryBlack';
  import AppContentTitle from '@/components/ui/titles/AppContentTitle';
  import AppSectionDefaultTemplate from '@/components/layout/templates/section/AppSectionTemplateDefault';

  // Mixins
  import {mixinRoutesHandler} from '@/mixins/routes-handler';

  // SVG
  import AirlinesSvg from '@/components/ui/svg/Airlines';
  import FinancialSvg from '@/components/ui/svg/Financial';
  import MallsSvg from '@/components/ui/svg/Malls';
  import HospitalitySvg from '@/components/ui/svg/Hospitality';
  import TelecomSvg from '@/components/ui/svg/Telecom';
  import MediaSvg from '@/components/ui/svg/Media';

  export default {
      name: 'AppViewTemplateIndustryProfile',

      props: {
        title: String,
        industryName: String,
        casesRouteName: String,
        brands: {
            type: Object,
        },
      },

      mixins: [mixinRoutesHandler],

      components: {
        AppViewTemplateSecondary, AppButtonSecondaryBlack, AppButtonPrimary, AirlinesSvg, FinancialSvg, MallsSvg,
        HospitalitySvg, TelecomSvg, MediaSvg, AppContentTitle, AppSectionDefaultTemplate,
      },

      methods: {
        getRoutePath(routeName) {
          return this._mixinGetRoutePath(routeName);
        },

        onButtonClick(routeName) {
          this._mixinGoToRouteName(routeName);
        },
      }
  }
</script>

<style lang="scss">
  .app-view-template-industry-profile {
    .industry-icon {
      display: block;
      width: 100px;
      height: 50px;
    }

    .airlines-icon {
      path {
        fill: #4A4647 !important;
      }
    }

    .financial-icon {
      path {
        fill: #4A4647 !important;
      }
    }

    .malls-icon {
      path, polygon {
        fill: #4A4647 !important;
      }
    }

    .hospitality-icon {
      path, rect {
        fill: #4A4647 !important;
      }
    }

    .telecom-icon {
      path {
        fill: #4A4647 !important;
      }
    }
  }
</style>
